export const SET_VISIBLE = 'SET_VISIBLE';
export const TOGGLE_CATEGORY = 'TOGGLE_CATEGORY';
export const CLOSE_CATEGORIES = 'CLOSE_CATEGORIES';



// WEBPACK FOOTER //
// ./src/screens/Class/ClassSidebar/store/types.js